/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Credential_Set_DescInputs */



/**
* | output |
* | --- |
* | "A member stored their own credential for the {provider} integration." |
*
* @param {Audit_Details_Integration_Credential_Set_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_credential_set_desc = /** @type {((inputs: Audit_Details_Integration_Credential_Set_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Credential_Set_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Mitglied hat eigene Zugangsdaten für die ${i?.provider}-Integration hinterlegt.`)
	return /** @type {LocalizedString} */ (`A member stored their own credential for the ${i?.provider} integration.`)
});